/* eslint-disable */
import { useEffect, useState } from 'react';
import ModalContacts from '../contactsPage/modal/ModalContacts';
import { useTranslation } from 'react-i18next';
import './startErrorPage.css';
import { Button } from '../../shared/ui';
import { useGetClientId } from '../../hookServices/clientId';
import { useContactUsTelegramPreferred } from '../../hookServices/useContactUsTelegramPreferred';
import { TELEGRAM_BOT } from '../../environment';
import ReactGA from 'react-ga';

const StartErrorPage = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  //eslint-disable-next-line
  const [pathName, portNumber] = window.location.href.split('=');
  const { t } = useTranslation();
  const { clientId } = useGetClientId();
  const { preferTelegram: preferTelegramForContact, lastPortForLink } = useContactUsTelegramPreferred();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  function callToSupport() {
    if (preferTelegramForContact && clientId) {
      ReactGA.event({
        category: 'contacts',
        action: 'telegram from start error page (last session port < 30 kW)',
      });
      window.open(
        `https://t.me/${TELEGRAM_BOT}?start=${encodeURIComponent(clientId)}-${lastPortForLink || portNumber || ''}`,
        '_blank'
      );
    } else {
      setIsOpen(true);
    }
  }

  return (
    <>
      <div className={'errorStart-container'}>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        {!isOpenModal && (
          <>
            <div className={'errorStart-message'}>
              <span>{t('errorStart.portConnectedQuestion', { portNumber })}</span>
              <br />
              <br />
              <span>{t('errorStart.ifSoPleaseDo')}</span>
              <br />
              {t('errorStart.alertMessage')}
            </div>
            <br />
            <Button className="mainBtn buttonForOfflineStation w-100" link={`/start?station=${portNumber}`}>
              <span className="mainBtnText"> {t('startNew')}</span>
            </Button>
            <Button onClick={callToSupport} className="mainBtn buttonForOfflineStation w-100">
              <span className="mainBtnText">{t('contactUs')}</span>
            </Button>
          </>
        )}
        <ModalContacts modalOpen={isOpen} setModalOpen={setIsOpen} />
      </div>
    </>
  );
};

export default StartErrorPage;
